/*!
 * Mortgage Cost Optimizer™ v1
 * Educational modeling tool. No DOM dependencies outside #mco-root.
 */
(function(){
  "use strict";

  var root = document.getElementById("mco-root");
  if(!root) return;

  var screens = [
    "intro","purpose","timeline","purchase","down","card_count","cards",
    "reporting","mortgage_late","other_lates","collections","hidden_risks","analysis","dashboard"
  ];

  var stepScreens = screens.filter(function(x){ return ["intro","analysis","dashboard"].indexOf(x) === -1; });
  var current = "intro";

  var state = {
    purpose:null,
    timeline:null,
    purchase_range:null,
    down_payment:null,
    card_count:null,
    cards:[],
    cards_reporting:null,
    mortgage_late:null,
    other_lates:null,
    collections:null,
    hidden_risks:[]
  };

  function $(sel, ctx){ return (ctx || root).querySelector(sel); }
  function $all(sel, ctx){ return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function num(v){ return Number(String(v || "").replace(/[^0-9.]/g,"")) || 0; }
  function money(n){ return "$" + Math.round(n || 0).toLocaleString("en-US"); }
  function pct(n){ return Math.round((n || 0) * 100) + "%"; }

  function show(name){
    current = name;
    $all(".mco-screen").forEach(function(s){
      s.classList.toggle("is-active", s.getAttribute("data-screen") === name);
    });
    if(name === "cards") buildCards();
    if(name === "analysis") runAnalysis();
    if(name === "dashboard") renderDashboard();
    drawProgress();
  }

  function drawProgress(){
    var idx = stepScreens.indexOf(current);
    var total = stepScreens.length;
    $all("[data-step-label]").forEach(function(el){
      var s = el.closest(".mco-screen").getAttribute("data-screen");
      var i = stepScreens.indexOf(s);
      el.textContent = i >= 0 ? (i + 1) + "/" + total : "";
    });
    $all(".mco-progress").forEach(function(p){
      p.innerHTML = "";
      for(var i=0;i<5;i++){
        var span = document.createElement("span");
        var fill = current === "dashboard" ? 1 : Math.max(.05, (idx + 1) / total);
        if(i < Math.ceil(fill * 5)) span.className = "is-on";
        p.appendChild(span);
      }
    });
  }

  function screen(){ return $('.mco-screen[data-screen="' + current + '"]'); }
  function setError(msg){
    var box = $(".mco-error", screen());
    if(!box) return;
    box.textContent = msg || "";
    box.classList.toggle("is-visible", !!msg);
  }

  function selectedValue(){
    var sel = $(".mco-options button.is-selected", screen());
    return sel ? sel.getAttribute("data-value") : null;
  }

  function saveCurrent(){
    setError("");
    var sc = screen();
    var key = sc.getAttribute("data-key");
    if(!key) return true;

    if(key === "card_count"){
      var count = Math.min(8, Math.max(0, Math.round(num($('[data-input="card_count"]', sc).value))));
      if(!count) return fail("Enter how many open cards to model.");
      state.card_count = count;
      return true;
    }

    if(key === "cards"){
      var rows = $all("[data-card-row]", sc);
      var cards = [];
      for(var i=0;i<rows.length;i++){
        var bal = num($('[data-card-balance]', rows[i]).value);
        var lim = num($('[data-card-limit]', rows[i]).value);
        if(lim <= 0) return fail("Enter a credit limit for each card.");
        if(bal > lim * 1.35) return fail("One balance looks much higher than the limit. Please check it.");
        cards.push({ balance:bal, limit:lim, utilization: lim ? bal / lim : 0 });
      }
      state.cards = cards;
      return true;
    }

    if(key === "cards_reporting"){
      var reporting = Math.round(num($('[data-input="cards_reporting"]', sc).value));
      if(reporting < 0) return fail("Enter the number of cards reporting balances.");
      if(state.card_count && reporting > state.card_count) return fail("Cards reporting balances cannot exceed total open cards.");
      state.cards_reporting = reporting;
      return true;
    }

    if(sc.getAttribute("data-multi") === "true"){
      var vals = $all(".mco-options button.is-selected", sc).map(function(b){ return b.getAttribute("data-value"); });
      if(!vals.length) return fail("Select at least one answer to continue.");
      state[key] = vals;
      return true;
    }

    var value = selectedValue();
    if(!value) return fail("Select an answer to continue.");
    state[key] = value;
    return true;
  }

  function fail(msg){ setError(msg); return false; }

  function next(){
    if(!saveCurrent()) return;
    if(current === "hidden_risks") return show("analysis");
    var idx = screens.indexOf(current);
    show(screens[Math.min(screens.length - 1, idx + 1)]);
  }

  function back(){
    if(current === "intro") return;
    var idx = screens.indexOf(current);
    show(screens[Math.max(0, idx - 1)]);
  }

  function buildCards(){
    var list = $("[data-card-list]");
    if(!list) return;
    var count = Math.min(8, Math.max(1, state.card_count || 1));
    list.innerHTML = "";
    for(var i=1;i<=count;i++){
      var row = document.createElement("div");
      row.className = "mco-card-entry";
      row.setAttribute("data-card-row","");
      row.innerHTML = ''
        + '<div class="mco-card-title">Card ' + i + '</div>'
        + '<div class="mco-card-fields">'
        + '<div class="mco-field"><label>Balance</label><input class="mco-input" data-money data-card-balance inputmode="numeric" placeholder="$"></div>'
        + '<div class="mco-field"><label>Credit limit</label><input class="mco-input" data-money data-card-limit inputmode="numeric" placeholder="$"></div>'
        + '</div>';
      list.appendChild(row);
    }
  }

  function formatMoneyInput(input){
    var raw = String(input.value || "").replace(/[^0-9]/g,"");
    input.value = raw ? "$" + Number(raw).toLocaleString("en-US") : "";
  }

  function purchasePrice(){
    var map = { under_300:250000, "300_500":400000, "500_750":625000, "750_plus":850000, unknown:400000 };
    return map[state.purchase_range] || 400000;
  }

  function downPct(){
    var map = { lt5:.03, "5":.05, "10":.10, "15":.15, "20":.20, unknown:.05 };
    return map[state.down_payment] || .05;
  }

  function targetReporting(open){
    if(open <= 1) return open;
    return Math.max(1, Math.ceil(open * .5) - 1);
  }

  function analyze(){
    var cards = state.cards || [];
    var totalBal = cards.reduce(function(s,c){ return s + c.balance; }, 0);
    var totalLim = cards.reduce(function(s,c){ return s + c.limit; }, 0);
    var overallUtil = totalLim ? totalBal / totalLim : 0;
    var sorted = cards.map(function(c,i){
      var u = c.limit ? c.balance / c.limit : 0;
      var pressure = 0;
      if(u >= 1) pressure = 100;
      else if(u >= .9) pressure = 90;
      else if(u >= .7) pressure = 75;
      else if(u >= .5) pressure = 58;
      else if(u >= .3) pressure = 35;
      else if(u > 0) pressure = 15;
      return {
        index:i+1,
        balance:c.balance,
        limit:c.limit,
        utilization:u,
        pressure:pressure,
        to49: Math.max(0, c.balance - c.limit * .49),
        to29: Math.max(0, c.balance - c.limit * .29),
        to9: Math.max(0, c.balance - c.limit * .09)
      };
    }).sort(function(a,b){ return b.pressure - a.pressure || b.utilization - a.utilization; });

    var highCards = sorted.filter(function(c){ return c.utilization >= .5; }).length;
    var maxed = sorted.filter(function(c){ return c.utilization >= .9; }).length;
    var open = state.card_count || cards.length || 0;
    var reporting = state.cards_reporting || cards.filter(function(c){ return c.balance > 0; }).length;
    var target = targetReporting(open);
    var reportingExcess = Math.max(0, reporting - target);

    var risk = 0;
    if(overallUtil >= .75) risk += 38;
    else if(overallUtil >= .5) risk += 28;
    else if(overallUtil >= .3) risk += 16;
    else if(overallUtil >= .1) risk += 6;

    risk += highCards * 8 + maxed * 10 + reportingExcess * 7;
    if(state.mortgage_late === "yes") risk += 32;
    if(state.other_lates === "recent_12") risk += 18;
    if(state.other_lates === "multiple") risk += 14;
    if(state.collections === "one_active") risk += 22;
    if(state.collections === "multiple_active") risk += 30;
    if(state.collections === "paid") risk += 8;
    if((state.hidden_risks || []).indexOf("rolling_lates") !== -1) risk += 22;
    if((state.hidden_risks || []).indexOf("auto_lease_grounding") !== -1) risk += 20;
    if((state.hidden_risks || []).indexOf("recent_new_credit") !== -1) risk += 12;
    if((state.hidden_risks || []).indexOf("identity_or_unknown") !== -1) risk += 16;

    risk = Math.min(100, Math.round(risk));

    var rating = "Strong";
    if(risk >= 75) rating = "High Impact";
    else if(risk >= 55) rating = "Needs Attention";
    else if(risk >= 35) rating = "Moderate";
    else if(risk >= 18) rating = "Strong";

    var price = purchasePrice();
    var loan = price * (1 - downPct());
    var costLow = Math.round((risk / 100) * 380 + (downPct() < .2 ? 120 : 0));
    var costHigh = Math.round(costLow + 140 + (risk / 100) * 260);

    var primary = "No major pressure detected";
    var primaryNote = "The model did not identify a major optimization pressure point.";
    if(state.mortgage_late === "yes"){ primary = "Recent mortgage late"; primaryNote = "This can affect mortgage approval policy and timing review."; }
    else if(state.collections === "multiple_active" || state.collections === "one_active"){ primary = "Active collection"; primaryNote = "Active derogatory items can create lender review pressure."; }
    else if(maxed > 0){ primary = "Maxed or near-maxed card"; primaryNote = "Cards near 90–100% are usually high priority in the optimizer."; }
    else if(highCards > 0){ primary = "High card utilization"; primaryNote = "Cards above 50% may create mortgage-cost pressure."; }
    else if(reportingExcess > 0){ primary = "Too many cards reporting balances"; primaryNote = "The model identified more reporting balances than the target pattern."; }
    else if((state.hidden_risks || []).indexOf("rolling_lates") !== -1){ primary = "Rolling late pattern"; primaryNote = "A loan may be staying one month behind due to payment application pattern."; }

    return {
      risk:risk,
      rating:rating,
      purchasePrice:price,
      loan:loan,
      costLow:costLow,
      costHigh:costHigh,
      cards:sorted,
      overallUtil:overallUtil,
      totalBal:totalBal,
      totalLim:totalLim,
      highCards:highCards,
      maxed:maxed,
      reporting:reporting,
      targetReporting:target,
      reportingExcess:reportingExcess,
      primary:primary,
      primaryNote:primaryNote
    };
  }

  function pillClass(pressure){
    if(pressure >= 75) return "high";
    if(pressure >= 35) return "med";
    return "low";
  }

  function renderDashboard(){
    var r = analyze();
    try { localStorage.setItem("mortgage_cost_optimizer_result", JSON.stringify({answers:state,result:r,generatedAt:new Date().toISOString()})); } catch(e){}

    $("#mcoRating").textContent = r.rating;
    $("#mcoRatingCopy").textContent = "Workspace risk score: " + r.risk + "/100. This is an educational mortgage-cost model.";
    $("#mcoCost").textContent = money(r.costLow) + "–" + money(r.costHigh) + "/mo";
    $("#mcoAssumption").textContent = "Illustration based on a " + money(r.purchasePrice) + " purchase scenario.";
    $("#mcoPrimary").textContent = r.primary;
    $("#mcoPrimaryNote").textContent = r.primaryNote;

    var table = $("#mcoCardTable");
    table.innerHTML = "";
    if(!r.cards.length){
      table.innerHTML = '<div class="mco-list-item"><b>No cards modeled</b><p>The optimizer needs card balances and limits to build a paydown priority map.</p></div>';
    } else {
      r.cards.forEach(function(c){
        var row = document.createElement("div");
        row.className = "mco-table-row";
        row.innerHTML = ''
          + '<div><span>Card</span><b>Card ' + c.index + '</b></div>'
          + '<div><span>Usage</span><b>' + pct(c.utilization) + '</b></div>'
          + '<div><span>Pressure</span><b><i class="mco-pill ' + pillClass(c.pressure) + '">' + (c.pressure >= 75 ? "High" : c.pressure >= 35 ? "Medium" : "Low") + '</i></b></div>'
          + '<div><span>Modeled threshold</span><b>' + (c.to49 > 0 ? money(c.to49) + " to get below 49%" : "Already below 50%") + '</b></div>';
        table.appendChild(row);
      });
    }

    var opp = $("#mcoOpportunities");
    opp.innerHTML = "";
    addItem(opp, "Overall card usage", "Total modeled utilization is " + pct(r.overallUtil) + ". Lower thresholds may reduce mortgage-cost pressure.");
    if(r.highCards) addItem(opp, "Cards above 50%", r.highCards + " card(s) are above 50%. The optimizer prioritizes these before smaller balances.");
    if(r.reportingExcess) addItem(opp, "Reporting balance pattern", "Model target: about " + r.targetReporting + " card(s) reporting balances. Current: " + r.reporting + ".");
    if(!r.highCards && !r.reportingExcess) addItem(opp, "Balance pattern", "No major card-level pressure detected from entered data.");

    var risks = $("#mcoRiskChecks");
    risks.innerHTML = "";
    var selected = state.hidden_risks || [];
    if(state.mortgage_late === "yes") addItem(risks, "Mortgage late policy check", "A mortgage late within 12 months may affect mortgage eligibility timing.");
    if(state.collections === "one_active" || state.collections === "multiple_active") addItem(risks, "Active collection check", "Active collection/charge-off items may need lender-specific review.");
    if(selected.indexOf("rolling_lates") !== -1) addItem(risks, "Rolling late pattern", "Possible one-month-behind payment pattern. Verify how payments are being applied.");
    if(selected.indexOf("auto_lease_grounding") !== -1) addItem(risks, "Returned lease grounding issue", "Returned lease may not have been grounded correctly. Review lease closure and reporting.");
    if(selected.indexOf("identity_or_unknown") !== -1) addItem(risks, "Unrecognized account", "Unrecognized accounts should be verified before relying on mortgage readiness.");
    if(selected.indexOf("recent_new_credit") !== -1) addItem(risks, "New credit timing", "New accounts or inquiries before mortgage may create timing pressure.");
    if(!risks.children.length) addItem(risks, "No hidden risk selected", "The hidden risk checklist did not identify one of the modeled traps.");

    var tl = $("#mcoTimeline");
    tl.innerHTML = "";
    addTime(tl, "Next 30 days", r.primary === "Recent mortgage late" ? "Confirm lender timing rules before optimizing balances." : "Reduce high-pressure card thresholds and avoid new credit.");
    addTime(tl, "Next 60 days", r.reportingExcess ? "Lower the number of cards reporting balances toward the model target." : "Stabilize reporting pattern and monitor updates.");
    addTime(tl, "Next 90 days", "Re-run the optimizer before application and compare cost scenario change.");
  }

  function addItem(parent,title,body){
    var div = document.createElement("div");
    div.className = "mco-list-item";
    div.innerHTML = "<b>" + title + "</b><p>" + body + "</p>";
    parent.appendChild(div);
  }

  function addTime(parent,title,body){
    var div = document.createElement("div");
    div.className = "mco-timebox";
    div.innerHTML = "<span>" + title + "</span><b>Optimization phase</b><p>" + body + "</p>";
    parent.appendChild(div);
  }

  function runAnalysis(){
    var items = $all(".mco-analysis-list li");
    items.forEach(function(li){ li.classList.remove("is-done"); li.textContent = li.textContent.replace(/^✓\s*/,""); });
    items.forEach(function(li,i){
      setTimeout(function(){ li.classList.add("is-done"); li.textContent = "✓ " + li.textContent.replace(/^✓\s*/,""); }, 350 + i*500);
    });
    setTimeout(function(){ show("dashboard"); }, 2800);
  }

  root.addEventListener("click", function(e){
    var opt = e.target.closest(".mco-options button");
    if(opt && root.contains(opt)){
      var box = opt.closest(".mco-options");
      var screenEl = opt.closest(".mco-screen");
      var multi = screenEl.getAttribute("data-multi") === "true";
      if(multi){
        if(opt.hasAttribute("data-exclusive")){
          $all("button", box).forEach(function(b){ b.classList.remove("is-selected"); });
          opt.classList.add("is-selected");
        } else {
          var ex = $('[data-exclusive="true"]', box);
          if(ex) ex.classList.remove("is-selected");
          opt.classList.toggle("is-selected");
        }
      } else {
        $all("button", box).forEach(function(b){ b.classList.remove("is-selected"); });
        opt.classList.add("is-selected");
      }
      setError("");
      return;
    }
    if(e.target.closest("[data-next]")) return next();
    if(e.target.closest("[data-back]")) return back();
    if(e.target.closest("[data-reset]")){
      try { localStorage.removeItem("mortgage_cost_optimizer_result"); } catch(err){}
      location.reload();
    }
  });

  root.addEventListener("input", function(e){
    var input = e.target.closest("input");
    if(!input) return;
    if(input.hasAttribute("data-money")) formatMoneyInput(input);
    setError("");
  });

  root.addEventListener("keydown", function(e){
    if(e.key !== "Enter") return;
    var input = e.target.closest("input");
    if(!input) return;
    e.preventDefault();
    next();
  });

  drawProgress();
})();